export default __webpack_public_path__ + "static/media/S-PU1H5_Gallery_4.e36e9faf.jpg";